import ResourceCard from '@/components/base/ResourceCard';
import { getLatestResources } from '@/mocks/resources';
import { getLatestArticles } from '@/mocks/articles';
import { Link } from 'react-router-dom';

export default function LatestResources() {
  const latestResources = getLatestResources(6);
  const latestArticles = getLatestArticles(3);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-end justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-2">
                  最新收录资源
                </h2>
                <p className="text-foreground-500 text-sm">
                  持续更新，发现更多免费好资源
                </p>
              </div>
              <Link
                to="/categories"
                className="hidden sm:flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {latestResources.map((resource) => (
                <ResourceCard key={resource.id} {...resource} />
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-end justify-between mb-8">
              <div>
                <h2 className="text-2xl font-bold text-foreground-900 font-heading mb-2">
                  精选文章
                </h2>
                <p className="text-foreground-500 text-sm">
                  免费资源使用指南与技巧
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-4">
              {latestArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 transition-all duration-200"
                >
                  <h3 className="text-foreground-900 font-semibold text-sm mb-1.5 group-hover:text-primary-600 transition-colors font-heading line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2 mb-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-3 text-foreground-400 text-[11px]">
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      {article.publishDate}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {article.readTime}
                    </span>
                  </div>
                </Link>
              ))}

              <Link
                to="/articles"
                className="flex items-center justify-center gap-1 px-4 py-3 bg-secondary-50 hover:bg-secondary-100 text-secondary-700 rounded-lg text-sm font-medium transition-colors mt-2"
              >
                阅读更多文章
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}